import React from "react";

export default function BsTelegram() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#i)">
        <path
          d="M24 12.082a12 12 0 1 1-24 0 12 12 0 0 1 24 0ZM12.43 8.941a583.073 583.073 0 0 0-6.998 3.015c-.568.225-.866.447-.893.663-.045.364.413.508 1.035.705l.263.082c.612.2 1.437.432 1.864.441.39.01.824-.15 1.302-.48 3.268-2.206 4.956-3.32 5.061-3.345.075-.018.18-.038.249.024.07.062.063.18.055.212-.045.194-1.84 1.862-2.768 2.726-.29.27-.495.46-.537.504-.093.094-.187.187-.283.279-.57.549-.995.96.023 1.632.49.324.883.589 1.275.856.426.291.852.58 1.404.944.14.09.275.187.405.28.496.354.945.672 1.495.621.322-.03.653-.33.821-1.23.398-2.126 1.179-6.729 1.359-8.626a2.14 2.14 0 0 0-.02-.473.506.506 0 0 0-.17-.325.79.79 0 0 0-.465-.14c-.45.008-1.145.249-4.476 1.635Z"
          fill="#currentColor"
        />
      </g>
      <defs>
        <clipPath id="i">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
